import type { LineAreaChartPoint } from "@/shared/charts";
import type { DensityTrendPoint } from "@/features/deployment-dashboard/widgets/charts/density-trend/types";

export function getDensityTrendErrorMessage(
  error: Error | string | null | undefined
): string | null {
  if (error == null) return null;
  return typeof error === "string" ? error : error.message;
}

export function mapDensityTrendToLineAreaChartData(
  data: DensityTrendPoint[]
): LineAreaChartPoint[] {
  return data.map((point) => ({
    x: point.period,
    timestamp: point.timestamp,
    value: point.density,
  }));
}
